  <gen-dynamic-form class="inner-form"
                    (formChange)="updateForm($event.form, $event.updated)"
                    [formData]="formData"
                    [formName] = "formName"
                    [formVertical]="true"
                    [listenToDataChange]="true"
                    [editMode]="false"
                    [mode]="'form'"
                    (validateChange)="updateValidate($event)">
  </gen-dynamic-form>
  <gen-button
    class="password-editor-details-button"
    [type]="'secondary'"
    [text]="buttonTitle"
    [disabled]="!buttonEnabled"
    (click)="Execute()">
  </gen-button>  